module.exports = __webpack_public_path__ + "img/banner5.34fdc216.png";